import type { FC } from 'react';
import type { Booking } from '@/types/domain/bookings';
import { Flex, Icon, Table, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { formatBookingDate } from '@/components/BookingsTable/formatBookingDate';
import { useBookings } from '@/queries/useBookings';

export const BookingsTable: FC = () => {
    const { data: bookings } = useBookings();
    const { t } = useTranslation();

    return (
        <Table
            block
            columns={[
                {
                    key: 'booking',
                    title: t('Events_Bookings_Table_Booking'),
                    render: (_: unknown, entity: Booking) => (
                        <Flex vertical gap={4}>
                            <Typography.Paragraph level={3} color="textBodySecondary">
                                {entity.position.name}
                            </Typography.Paragraph>
                            <Typography.Description color="textTertiary">
                                {`${entity.user.first_name} ${entity.user.last_name} - ${entity.user.id}`}
                            </Typography.Description>
                        </Flex>
                    )
                },
                {
                    key: 'period',
                    title: t('Events_Bookings_Table_Time'),
                    render: (_: unknown, entity: Booking) => (
                        <Typography.Paragraph level={3} color="textBodySecondary">
                            {formatBookingDate(entity, t)}
                        </Typography.Paragraph>
                    )
                }
            ]}
            data={bookings}
            rowKey={b => b.id}
            empty={{
                icon: <Icon.CalendarClock size={48} color="textTertiary" />,
                title: t('Events_Bookings_Table_Empty')
            }}
        />
    );
};
